// extracted by mini-css-extract-plugin
module.exports = {"containerBackground":"general-module--containerBackground--3FhbJ"};